import { ReactNode } from 'react';
import { chatttSDKChannel } from 'services/chattt/sdk';
import { useQuery } from 'components/RouterQuery';
import { isOfficialChannel } from '../services/chattt';

export const InviteVisibleControl = (props: { children: ReactNode }) => {
  const { channel } = useQuery();
  // 注册和登录2个场景
  // 注册可以客户端和网页，从两个源取key，登录只允许客户端登录，从chatt里拿，channel是为空
  if (chatttSDKChannel && !isOfficialChannel) return <></>;
  if (channel) return <></>;
  return <>{props.children}</>;
};
